import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import user from './services/redux/user/reducers';
import object from './services/redux/object/reducers';
import document from './services/redux/document/reducers';
import costs from './services/redux/costs/reducers';
import map from './services/redux/map/reducers';
import image from './services/redux/image/reducers';
import auth from './services/redux/auth/reducers';

const allReducers = combineReducers({
  auth,
  user,
  object,
  document,
  costs,
  map,
  image,
  form: formReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STATE') {
  	// clear state...
  	state = undefined;
  }

  return allReducers(state, action);
};

export default rootReducer;

